import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarPlus, CalendarCheck } from "lucide-react";
import { api, extractError } from "@/lib/api";

const Ctx = createContext(null);

// Loads today's daily-plan status for every task of a project
export function PlanStatusProvider({ projectId, tasks, children }) {
    const [status, setStatus] = useState({});
    const load = useCallback(async () => {
        try { setStatus((await api.get("/daily-plans/task-status", { params: { project_id: projectId } })).data.tasks); }
        catch (e) { console.error("Load plan status failed:", e); }
    }, [projectId]);
    useEffect(() => { load(); }, [load, tasks]);
    return <Ctx.Provider value={{ status, reload: load }}>{children}</Ctx.Provider>;
}

export function AddToPlanBtn({ task }) {
    const ctx = useContext(Ctx);
    if (!ctx) return null;
    const s = ctx.status[task.id] || { mine: false, others: [] };
    const add = async () => {
        try { const { data } = await api.post("/daily-plans/add-task", { task_id: task.id }); toast.success(`Aggiunta al piano di ${new Date(`${data.date}T00:00:00`).toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long" })}`); ctx.reload(); }
        catch (e) { toast.error(extractError(e)); }
    };
    const others = s.others.length ? <span className="text-[11px] text-neutral-500 whitespace-nowrap" data-testid={`plan-others-${task.id}`}>nel piano di {s.others.join(", ")}</span> : null;
    if (s.mine) return (
        <span className="inline-flex items-center gap-1.5">
            <span className="inline-flex items-center gap-1 text-[11px] text-emerald-700 whitespace-nowrap" data-testid={`plan-mine-${task.id}`}><CalendarCheck size={12} /> già nel piano di oggi</span>{others}
        </span>
    );
    return (
        <span className="inline-flex items-center gap-1.5">
            {others}
            <button onClick={add} title="Aggiungi al piano giornaliero" data-testid={`add-to-plan-${task.id}`}
                className="text-neutral-600 hover:text-neutral-900 border border-neutral-200 hover:border-neutral-400 rounded px-1.5 py-0.5 inline-flex items-center gap-1 text-[11px] whitespace-nowrap">
                <CalendarPlus size={13} />
            </button>
        </span>
    );
}
